
class ExternalLoader {

    constructor(doc) {
        this.document = doc;
        this.current = 0;
        this.max = 0;
    }

    /**
     * Load Generic External Files
     */
    load(urls) {
        return new Promise((resolve, reject) => {

            this.max = urls.length;

            // Define the done callback
            let done = () => {
                this.current++;
                if (this.current === this.max) {
                    resolve();
                }
            };

            // Put all the resources into header
            for (let url of urls) {
                if (url.endsWith(".js")) {
                    this.loadScript(url, done);
                } else if (url.endsWith(".css")) {
                    this.loadStyle(url, done);
                } else {
                    this.loadResource(url, done);
                }
            }
        });
    }

    loadScript(script, done = null) {
        let scriptTag = this.document.createElement('script');
        scriptTag.setAttribute('src', script);
        if (done) scriptTag.onload = () => { done() };
        scriptTag.async = false;
        scriptTag.defer = true;
        this.document.head.appendChild(scriptTag);
    }

    loadStyle(style, done = null) {
        let linkTag = this.document.createElement('link');
        linkTag.setAttribute('rel', 'stylesheet');
        linkTag.setAttribute('href', style);
        if (done) linkTag.onload = () => { done() };
        linkTag.async = false;
        linkTag.defer = true;
        this.document.head.appendChild(linkTag);
    }

    loadResource(resource, done = null) {
        let linkTag = this.document.createElement('link');
        linkTag.setAttribute('rel', 'resource');
        linkTag.setAttribute('type', 'application/l10n');
        linkTag.setAttribute('href', resource);
        if (done) linkTag.onload = () => { done() };
        linkTag.async = false;
        linkTag.defer = true;
        this.document.head.appendChild(linkTag);
    }

}

export default ExternalLoader;